import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../shared/auth-guard';

// Componentes
import { ManagerComponent } from '../../app-manager/manager.component';
import { InvComponent } from '../../app-manager/invoicing-services/inv.component';
import { InvTabsComponent } from '../../app-manager/invoicing-services/inv-tabs/inv-tabs.component';
import { InvInvoicingServiceComponent } from '../../app-manager/invoicing-services/inv-invoicing-service/inv-invoicing-service.component';
import { InvClientListComponent } from '../../app-manager/invoicing-services/inv-client-list/inv-client-list.component';
import { InvPlatformListComponent } from '../../app-manager/invoicing-services/inv-platform-list/inv-platform-list.component';
import { InvReceiverListComponent } from '../../app-manager/invoicing-services/inv-receiver-list/inv-receiver-list.component';
import { InvCompanyInfoComponent } from '../../app-manager/invoicing-services/inv-company-info/inv-company-info.component';
import { InvAuthorizedListComponent } from '../../app-manager/invoicing-services/inv-authorized-list/inv-authorized-list.component';
import { InvInvoicingServiceListComponent } from '../../app-manager/invoicing-services/inv-invoicing-service-list/inv-invoicing-service-list.component';
import { InvAccessibilityComponent } from '../../app-manager/invoicing-services/inv-accessibility/inv-accessibility.component';

// Servicios

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    SharedModule,
    RouterModule.forRoot([
      {
        path: 'empresas/accesibilidad',
        component: InvAccessibilityComponent,
        pathMatch: 'full'
      },
      {
        path: 'empresas',
        component: ManagerComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'listado',
            component: InvInvoicingServiceListComponent,
            pathMatch: 'full'
          },
          {
            path: 'nueva-empresa-servicio-facturacion',
            component: InvInvoicingServiceComponent,
            pathMatch: 'full'
          },
          {
            path: '',
            component: InvComponent,
            pathMatch: 'full'
          },
          {
            path: ':identifier',
            component: InvComponent,
            children: [
              {
                path: '',
                component: InvTabsComponent,
                children: [
                  {
                    path: '',
                    redirectTo: 'plataformas',
                    pathMatch: 'full'
                  },
                  {
                    path: 'plataformas',
                    component: InvPlatformListComponent,
                    pathMatch: 'full'
                  },
                  {
                    path: 'clientes',
                    component: InvClientListComponent,
                    pathMatch: 'full'
                  },
                  {
                    path: 'receptores',
                    component: InvReceiverListComponent,
                    pathMatch: 'full'
                  }
                ]

              }
            ]
          }
        ]
      }
    ])
  ],
  providers: [],
  declarations: [
    InvComponent,
    InvTabsComponent,
    InvInvoicingServiceComponent,
    InvClientListComponent,
    InvPlatformListComponent,
    InvReceiverListComponent,
    InvCompanyInfoComponent,
    InvAuthorizedListComponent,
    InvInvoicingServiceListComponent,
    InvAccessibilityComponent
  ]
})
export class InvoicingServicesModule { }



// WEBPACK FOOTER //
// ./src/app/modules/invoicing-services/invoicing-services.module.ts